import React, { Component, useState, useRef, useEffect } from 'react'
import { CardDeck, Row, Col, Container, Card, Button, OverlayTrigger, Popover, Overlay, ListGroup, ListGroupItem } from 'react-bootstrap'
import FeatherIcon from 'feather-icons-react';

import '../../css/NotificationPopper.css'
import { selectBranch } from '../../services/actions/action';

function UserAccountsPopper(props) {

    const [show, setShow] = useState(false);
    const [target, setTarget] = useState(null);
    const [UserBranches, setUserBranches] = useState(props.data);
    const [selectedBranchID, setSelectedBranchID] = useState(props.data.selectedBranchId)
    const [selectedBranchNumber, setSelectedBranchNumber] = useState(props.data.selectedBranchNumber)
    const [selectedBranchName, setSelectedName] = useState(props.data.selectedBranchName)

    const ref = useRef(null);

    const handleClick = (event) => {
        setShow(false);
        setTarget(event.target);
    };

    // useEffect(() => {
    //     // Update the document title using the browser API
    //     //document.title = `You clicked ${count} times`;
    //     console.log("Branch Props are ", props)
    //   }, []);

    


    return (
        <div ref={ref}>
            <span>
                <div onClick={handleClick}>
                    <small>{props.data.selectedBranchNumber} - {props.data.selectedBranchName} </small>
                </div>
            </span>
            <Overlay
                show={show}
                target={target}
                trigger="focus"
                delay={{ show: 250, hide: 400 }}
                placement="bottom"
                container={ref.current}
                containerPadding={60}
                rootClose
                readOnly

            >
                <Popover id="popover-contained">
                    <Popover.Content className="text-center">
                        {props.data.userBranches &&
                            props.data.userBranches.map((el, index) => {
                                if (el.status == 'Active')
                                    return (
                                        <div className="CustomNavStyling" onClick={() => { props.selectBranchHandler({ id: el.id, Number: el.branchAccountNumber }); setShow(!show) }}><FeatherIcon className="iconspacing-Nav" icon="user" size="15" /><small>{el.branchAccountNumber}</small></div>
                                    )
                            })
                        }
                    </Popover.Content>
                </Popover>
            </Overlay>
        </div >
    );
}

export default UserAccountsPopper